import {createFileRoute} from '@tanstack/react-router';

import {parseNonEmpty} from '@/lib/search-params';
import {parseJobDetailTab, type JobDetailTab} from '@/modules/jobs/lib/detail-tabs';
import {JobDetailPage} from '@/modules/jobs/pages/JobDetailPage';

/**
 * URL state for the job detail, capturing the navigation path so the breadcrumb
 * can mirror it: `from="site"` + `siteId` roots at Sites › site › job, and when
 * that site was itself reached via a project, `projectId` extends it to
 * Projects › project › site › job. With no params it roots at Jobs › job.
 * `tab` selects the main-column tab — including which of the job's two reports
 * is open — so the choice survives a refresh or a shared link (DERP-168). All
 * optional so bare `/jobs/$jobId` links still work.
 */
export interface JobDetailSearch {
  from?: 'site';
  siteId?: string;
  projectId?: string;
  tab?: JobDetailTab;
}

const validateJobDetailSearch = (search: Record<string, unknown>): JobDetailSearch => ({
  from: search.from === 'site' ? 'site' : undefined,
  siteId: parseNonEmpty(search.siteId),
  projectId: parseNonEmpty(search.projectId),
  // Unknown values drop to undefined; the default depends on the job's status,
  // so JobDetailTabs resolves it.
  tab: parseJobDetailTab(search.tab),
});

export const Route = createFileRoute('/_authenticated/jobs/$jobId')({
  validateSearch: validateJobDetailSearch,
  component: JobDetailPage,
});
